<template>
	<my-dialog :visible.sync="showDetailVisible" :title="title" :close-on-click-modal="false" :modal="false" width="90%" @close="closeDialog()">
		<div class="main_bg">
			<div class="item_info border_Warningcolor">
				<el-descriptions :column="3" :border="true" title="申购单信息" :label-width="120">
					<el-descriptions-item label="所属门店">
						<span class="descriptions-item-value">{{ subscriptionInfo.storeName }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购人">
						<span class="descriptions-item-value">{{ subscriptionInfo.creator }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购时间">
						<span class="descriptions-item-value">{{ subscriptionInfo.createTime }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购单编号">{{ subscriptionInfo.code }}</el-descriptions-item>
					<el-descriptions-item label="申购状态">
						<span class="descriptions-item-value">{{ subscriptionInfo.stateStr }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="快递单号">
						<span class="descriptions-item-value">{{ subscriptionInfo.kdNo }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="备注">{{ subscriptionInfo.remark }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">申购商品信息</div>
					<div class="btnDiv"></div>
				</div>
				<el-table :cell-class-name="$moneyCellClass" :data="productTableData" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="typeName" label="类型" width="140"></el-table-column>
					<el-table-column prop="productName" label="系列" width="160"></el-table-column>
					<el-table-column prop="specification" label="商品名称" width="160"></el-table-column>
					<el-table-column prop="productBrand" label="商品品牌" width="160"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="70"></el-table-column>
					<el-table-column prop="realQty" label="实际数量" width="90"></el-table-column>
					<el-table-column prop="returnQuantity" label="退货数量" width="120">
						<template #default="scope">
							<el-input-number v-model.number="scope.row.returnQuantity" type="number" :min="0" size="mini" style="width: 100%" :max="scope.row.quantity" :step="1" :precision="0"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="reason" label="退货原因" width="180">
						<template #default="scope">
							<el-input v-model="scope.row.reason" type="textarea" placeholder="请输入退货原因" rows="2" :maxlength="100"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="unit" label="单位" width="70"></el-table-column>
					<el-table-column prop="productDate" label="生产日期" width="110"></el-table-column>
					<el-table-column prop="expireDate" label="过期日期" width="110"></el-table-column>
					<el-table-column prop="price" label="售价(元)" width="140"></el-table-column>
					<el-table-column prop="remark" label="备注" width="150"></el-table-column>
					<el-table-column prop="kdNo" label="快递单号" width="150"></el-table-column>
				</el-table>
			</div>
			<div class="item_info border_Blue">
				<div class="item_title">
					<div class="title">操作记录</div>
					<div class="btnDiv"></div>
				</div>
				<operationLog ref="operationLog"></operationLog>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog()">取消</el-button>
				<el-button v-if="subscriptionInfo.state == 7 && $checkBtnPermission('/subscription/index', 'returnQty')" size="small" :loading="loading" type="primary" @click="handleSubmitClick">
					退货
				</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script>
import { GetStoreSubscriptionDetail, StoreSubscriptionReturn } from "@/api/productApi.js";
import operationLog from "@/views/system/operationLog/businessOperationLog.vue";
export default {
	props: {
		storeList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showDetailVisible: false,
			loading: false,
			title: "申购单详情",
			subscriptionInfo: {},
			productTableData: []
		};
	},
	created() {},
	mounted() {},
	components: {
		operationLog
	},
	methods: {
		// 展示详情
		showReturnQty(keyId) {
			this.subscriptionInfo = {};
			this.productTableData = [];
			GetStoreSubscriptionDetail({
				keyId: keyId
			}).then((res) => {
				if (res.code == 1) {
					this.subscriptionInfo = res.data;
					this.productTableData = [];
					if (res.data.dtls != null && res.data.dtls.length > 0) {
						var index = 1;
						res.data.dtls.forEach((item) => {
							this.productTableData.push({
								rowNumber: index++,
								productKeyId: item.productTypeInfo.keyId,
								typeName: item.productTypeInfo.typeName,
								productName: item.productTypeInfo.productName,
								specification: item.productTypeInfo.specification,
								quantity: item.quantity,
								unit: item.productTypeInfo.unit,
								remark: item.remark,
								costMoney: item.costMoney,
								productDate: item.productDate,
								expireDate: item.expireDate,
								keyId: item.keyId,
								price: item.price,
								shippingCost: item.shippingCost,
								supplyName: item.supplyName,
								returnQuantity: 0,
								reason: "",
								realQty: item.realQty,
								kdNo: item.kdNo,
								productBrand: item.productBrand
							});
						});
					}
					this.title = "申购单退货";
				} else {
					this.$message.error(res.msg);
				}
			});
			this.showDetailVisible = true;
			this.$nextTick(() => {
				this.$refs.operationLog.showOperationLog(keyId);
			});
		},
		// 关闭详情弹出框
		closeDialog() {
			this.subscriptionInfo = {};
			this.showDetailVisible = false;
		},
		// 退货提交
		handleSubmitClick() {
			var isPass = true;
			var dtls = [];
			// 校验退货数量
			this.productTableData.forEach((item) => {
				if (item.returnQuantity > item.quantity) {
					this.$message.error("退货数量不能大于申购数量");
					isPass = false;
					return;
				}

				if (item.returnQuantity > 0) {
					if (item.reason == "") {
						this.$message.error("请输入退货原因");
						isPass = false;
						return;
					}
					dtls.push({
						keyId: item.keyId,
						qty: item.returnQuantity,
						remark: item.reason
					});
				}
			});
			if (!isPass) {
				return;
			}
			if (dtls.length == 0) {
				this.$message.error("请选择退货商品");
				return;
			}
			this.$confirm("确认退货吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				StoreSubscriptionReturn({
					keyId: this.subscriptionInfo.keyId,
					dtls: dtls
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message.success("退货成功");
							this.closeDialog();
							this.$parent.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>
<style scoped>
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.formDiv {
	border: 1px solid #e9e7e7;
	padding: 10px;
	border-radius: 5px;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border: 2px solid #e9e7e7;
}

.border_Blue {
	border-left: 5px solid #55aaff;
}

.border_Warningcolor {
	border-left: 5px solid #ff9900;
}

.border_Green {
	border-left: 5px solid #00cc66;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;
}

.title {
	display: inline-block;
	unicode-bidi: isolate;
}

.btnDiv {
	display: block;
	unicode-bidi: isolate;
	word-break: break-all;
}

.descriptions-item-value {
	display: inline-block;
	min-width: 100px;
	text-align: left;
}
</style>
